import React, { useState, useEffect } from 'react';
import { RiSignalWifiErrorFill } from "react-icons/ri";

const InternetChecking = (props) => {
    const [onlineStatus, setOnlineStatus] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setOnlineStatus(true);
        const handleOffline = () => setOnlineStatus(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <p className="internerConnectionError"> {onlineStatus ? ' ' :<><RiSignalWifiErrorFill/>  { process.env.REACT_APP_INTERNETCONNECTIONERROR} </>}</p>
    );
};

export default InternetChecking;
